export default __webpack_public_path__ + "static/media/logo.0071ff75.png";